import {
  MenuItemEvent,
  ItemEventListeners,
  GetItemEventListenersProps_v1,
} from './types';

const HOVERED = 'data-hovered';

export const createCommonListeners = (
  setIsHovered: GetItemEventListenersProps_v1['setIsHovered'],
): ItemEventListeners => ({
  onEnter: (e: MenuItemEvent) => {
    /*
      setting data-attribute directly to immediately show submenu.
      this is needed to have a possibility to calculate
      BoundingClientRect without delay
     */
    (e.currentTarget as HTMLElement).setAttribute(HOVERED, 'true');

    /*
      state is needed for stylable to properly apply styles from stylable panel
     */
    setIsHovered(true);
  },
  onLeave: (e: MenuItemEvent) => {
    (e.currentTarget as HTMLElement).removeAttribute(HOVERED);
    setIsHovered(false);
  },
});
